import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  createTask,
  getDepartment,
  getPosition,
  getUserByRole,
} from "../../../../redux/educator/actions";
import {
  selectDepartments,
  selectPositions,
  selectTasksLoading,
  selectUsersByRole,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  departments: selectDepartments(state),
  positions: selectPositions(state),
  users: selectUsersByRole(state),
  loading: selectTasksLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      createTask,
      getDepartment,
      getPosition,
      getUserByRole,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
